//
// Module for the Dynamic Flow Wizard's 'Favorite Destinations' step 
//
rs.module("content/development/codedemos/dynamicflowwizard/favoritedestinationsstep",

    ["controls/navigation/wizard"],

    function (wizard) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var addFavoriteDestinationLink = stepContainer.js(jsSelectors.addFavoriteDestinationLink);

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // Get the form (this will be the wizard form)
            var _form = stepContainer.closest("form");

            // Reset validation
            $.validator.resetValidation(_form);

            // Handle the Add Favorite Destination link click event
            if (addFavoriteDestinationLink) {

                addFavoriteDestinationLink.on('click', function () {

                    $.post(
                        {
                            url: backendUrls.setAddingFavoriteDestinationIndicator,
                            headers: wizard.getNavigationToken()
                        }
                    ).done(function (html, status, xhr) {

                        // Advance the wizard to the next step (Favorite Destination Add step)
                        wizardNextButton.click()

                    }).always(function (html, status, xhr) {

                    });
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);